<template>
  <div class="project-config-tab">
    <config-editor
      v-if="project && activeConfigData"
      ref="configEditor"
      :project="project"
      :loading="loading"
      :mode="editorMode"
      :config-data="activeConfigData"
      :main-domain="mainDomainData"
      :licenses="licenses"
      :supports="supports"
      :readonly="readonly"
      @update:hasChanges="$emit('update:hasChanges', $event)"
      @maintenance-submit="$emit('maintenance-submit', $event)"
    />
  </div>
</template>

<script>
  import { cloneDeep, merge } from 'lodash'
  import ConfigEditor from './ConfigEditor.vue'

  export default {
    name: 'ProjectConfigTab',
    components: {
      ConfigEditor,
    },
    props: {
      project: {
        type: Number,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      projectData: {
        type: Object,
        default: null,
      },
      mainDomainData: {
        type: Object,
        default: null,
      },
      selectedMirror: {
        type: Object,
        default: null,
      },
      licenses: {
        type: Array,
        default: () => [],
      },
      supports: {
        type: Array,
        default: () => [],
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:hasChanges', 'maintenance-submit'],
    computed: {
      editorMode() {
        return this.selectedMirror ? 'mirror' : 'main'
      },
      activeConfigData() {
        if (!this.selectedMirror) {
          return this.projectData ?? {}
        }

        const projectSettings = this.projectData?.settings || {}
        const mirrorSettings = this.selectedMirror?.settings || {}

        return {
          ...this.selectedMirror,
          settings: merge(cloneDeep(projectSettings), cloneDeep(mirrorSettings)),
        }
      },
    },
  }
</script>
